import { CollapsibleContent } from '@/lib/base/collapsible-content';

import { bold, InlineText, TimelineEvent } from '../components/shared';
import { TIMELINE_DESIGN_TOKENS } from '../design-tokens';
import type { SmsPayload } from '../types';
import { EVENT_TYPES } from '../types';
import type { EventComponentProps } from './types';

const SMS_LABELS: Record<string, string> = {
  [EVENT_TYPES.AHOY_SMS_SENT]: 'SMS sent',
  [EVENT_TYPES.AHOY_SMS_RECEIVED]: 'SMS received',
};

const META_TEXT_CLASS = `${TIMELINE_DESIGN_TOKENS.typography.subItem} text-secondary`;

export function SmsMessageEvent({ event }: EventComponentProps) {
  const payload = event.payload as SmsPayload | undefined;
  const label = SMS_LABELS[event.event_type_name] ?? 'SMS';
  const body = payload?.body;

  return (
    <TimelineEvent ariaLabel={label}>
      <TimelineEvent.Icon event={event} />
      <TimelineEvent.Content
        eventId={event.event_id}
        header={<InlineText>{bold(label)}</InlineText>}
        timestamp={event.occurred_at}
      >
        {payload?.direction && (
          <div className={META_TEXT_CLASS}>{payload.direction}</div>
        )}
        {body && (
          <div className='mt-2'>
            <CollapsibleContent maxCollapsedHeight={63}>
              <div className={`${META_TEXT_CLASS} whitespace-pre-wrap`}>
                {body}
              </div>
            </CollapsibleContent>
          </div>
        )}
      </TimelineEvent.Content>
    </TimelineEvent>
  );
}
